<template>
  <div class="enquiry-page">
    <div class="enquiry-information">
      <div class="enquiry-information-row">
        <span class="title">下单时间：</span>
        <span>{{ enquiryDetails.purchaseVoucherDate? enquiryDetails.purchaseVoucherDate :'-' }}</span>
      </div>
      <div class="enquiry-information-row">
        <span class="title">收货期限：</span>
        <span>{{ enquiryDetails.receiveDate? enquiryDetails.receiveDate :'-' }}</span>
      </div>
      <div class="enquiry-information-row">
        <span class="title">经办人：</span>
        <span>{{ enquiryDetails.transactorName? enquiryDetails.transactorName :'-' }}</span>
      </div>
      <div class="enquiry-information-row">
        <span class="title">收货地址：</span>
        <span>{{ enquiryDetails.receiverAddress? enquiryDetails.receiverAddress :'-' }}</span>
      </div>
      <div class="enquiry-information-row">
        <span class="title">备注：</span>
        <span>{{ enquiryDetails.remark ? enquiryDetails.remark :'-'}}</span>
      </div>
    </div>
    <div class="enquiry-product-list">
      <div class="product-list-title">
        <span>{{ enquiryDetails.contactCustomerName }}</span>
      </div>
      <div class="product-list-box">
        <div class="product-list" v-for="(item,index) in enquiryDetails.purchaseInquiryPriceItemVOList" :key="index">
          <div class="product-information" @click="btnlookDetails(item)">
            <div class="product-list-left">
              <img :src="item.productImageUrl? item.productImageUrl :goodsImg" alt="" class="image">
            </div>
            <div class="product-list-right">
              <div class="product-list-right-row name-price">
                <div class="name">
                  <span>{{ item.productName }}</span>
                </div>
              </div>
              <div class="product-list-right-row" style="padding: 5px 0">
                <span>{{ item.productModel }}</span>
              </div>
              <div class="product-list-right-row">
                <span>采购数：{{ item.goodsNumber }}</span>
              </div>
            </div>
          </div>
          <div class="product-list-number">
            <div class="add-number">
              <span class="title">可供应数量：</span>
              <div class="input-box">
                <div class="btn-num" @click="btndelNumber(item)">-</div>
                <input type="number" class="number-input" v-model="item.planNumber" :disabled="disabled" @blur="blurInput(item)">
                <div class="btn-num" @click="btnaddNumber(item)">+</div>
              </div>
            </div>
            <div class="price-input-box">
              <span class="title">请输入单价：</span>
              <input type="number" class="price-input" v-model="item.realPrice" :disabled="disabled" @blur="btnGoodsPrice">
            </div>
          </div>
        </div>
        <div class="product-number">
          <span class="number">共 {{ goodsNum }} 件</span>
          <span class="total-title">合计：</span>
          <span class="price">¥ <span style="font-size: 20px;">{{ goodsPrice }}</span></span>
        </div>
      </div>
    </div>
    <div class="offer-bottom" v-if="enquiryDetails.confirmFlag==0">
      <input type="number" class="price-box-input" id="value-num" v-model="realTotalAmount">
      <div class="btn-affirm" @click="btEnquiry">
        <span>提交报价</span>
      </div>
    </div>
    <enquiry-modal ref="enquirymodal" @handleOk="handleOk"></enquiry-modal>
  </div>
</template>
<script>
import enquiryModal from "./modules/enquiryModal.vue";
import { getfindpurchaseInquiryPriceById, setsubmitOffer } from "@/utils/api";
export default {
  name: "h5enquiry",
  data() {
    return {
      realTotalAmount: 0,
      purchaseInquiryPriceItemsVO: [],
      goodsPrice: null,
      goodsNum: null,
      enquiryDetails: {},
      goodsImg: require('../../assets/image/moren-01.png'),
      disabled: false
    };
  },
  components: {
    enquiryModal,
  },
  mounted() {
    this.getOrder();
  },
  methods: {
    // 点击减少数量
    btndelNumber(item) {
      if (item.planNumber > 0) {
        item.planNumber -= 1;
      } else {
        this.$message.warning("目前数量已为0");
      }
      this.goodsPrice = 0;
      this.goodsNum = 0;
      this.enquiryDetails.purchaseInquiryPriceItemVOList.map((item) => {
        this.goodsPrice += item.planNumber * item.realPrice;
        this.goodsNum += item.planNumber;
        this.realTotalAmount = this.goodsPrice;
      });
    },
    // 点击增加数量
    btnaddNumber(item) {
      if (item.planNumber < item.goodsNumber) {
        item.planNumber += 1;
      } else {
        this.$message.warning("目前数量达到询货数量");
      }
      this.goodsPrice = 0;
      this.goodsNum = 0;
      this.enquiryDetails.purchaseInquiryPriceItemVOList.map((item) => {
        this.goodsPrice += item.planNumber * item.realPrice;
        this.goodsNum += item.planNumber;
        this.realTotalAmount = this.goodsPrice;
      });
    },
    getOrder() {
      let header = {
        token:''
      };
      let params = {};
      let data = {};
      let url =
        "/order/api/purchaseInquiryPrice/noNeedToken/findPurchasePriceInfoInquiry/"+this.$route.query.id;
      this.isLoding = true;
      getfindpurchaseInquiryPriceById(url, params, header, data).then((res) => {
        if (res.code == 200) {
          this.goodsPrice = 0;
          this.goodsNum = 0;
          this.enquiryDetails = res.result;
          this.enquiryDetails.purchaseInquiryPriceItemVOList.map((item) => {
            this.goodsNum += item.planNumber;
            item.goodsNumber = item.planNumber;
            item.realPrice = null;
            this.realTotalAmount = this.goodsPrice;
          });
          if(res.result.confirmFlag==1) {
            this.disabled = true
          }
        }
        this.isLoding = false;
      });
    },
    // 可供货数量
    blurInput(item) {
      if (
        0 < parseInt(item.planNumber) &&
        parseInt(item.planNumber) < item.goodsNumber
      ) {
      } else {
        item.planNumber = item.goodsNumber;
        this.$message.warning("当前输入数量为无效数量");
      }
      this.goodsPrice = 0;
      this.goodsNum = 0;
      this.enquiryDetails.purchaseInquiryPriceItemVOList.map((item) => {
        this.goodsPrice += item.planNumber * item.realPrice;
        this.goodsNum += item.planNumber;
        this.realTotalAmount = this.goodsPrice;
      });
    },
    // 修改单价
    btnGoodsPrice() {
      this.goodsPrice = 0;
      this.goodsNum = 0;
      this.enquiryDetails.purchaseInquiryPriceItemVOList.map((item) => {
        this.goodsPrice += item.planNumber * item.realPrice;
        this.goodsNum += item.planNumber;
        this.realTotalAmount = this.goodsPrice;
      });
    },
    btEnquiry() {
      this.$refs.enquirymodal.showModal();
    },
    // 查看详情
    btnlookDetails(item) {
      this.$router.push("/h5/details?id=" + item.productId);
    },
    handleOk() {
      let header = {
        token:''
      };
      let params = {
        id: this.enquiryDetails.id,
        realTotalAmount: this.realTotalAmount,
        purchaseInquiryPriceItemVOList: [],
      };
      let data = {};
      this.enquiryDetails.purchaseInquiryPriceItemVOList.map((item) => {
        params.purchaseInquiryPriceItemVOList.push({
          realNumber: item.planNumber,
          realPrice: item.realPrice,
          id: item.id
        });
      });
      this.isLoding = true;
      setsubmitOffer(params, header, data).then((res) => {
        if (res.code == 200) {
          this.getOrder();
          this.$message.success("确认报价成功");
        } else {
          this.$message.error(res.logMessage)
        }
        this.isLoding = false;
      });
    },
  },
};
</script>
<style lang="scss">
/* 内容 */
.enquiry-page {
  padding: 14px 0 86px 0;
  background-color: #f0f1f5;
  position: relative;

  /* 商品信息 */
  .enquiry-information {
    padding: 11px 14px;
    margin: 0 14px;
    background-color: #ffffff;
    border-radius: 6px;
    font-size: 14px;
    .enquiry-information-row {
      padding: 9px 0;
      .title {
        color: #858585;
      }
    }
  }

  /* 商品列表 */
  .enquiry-product-list {
    padding: 0px 14px;
    margin: 0 14px;
    background-color: #ffffff;
    border-radius: 6px;
    font-size: 14px;
    margin-top: 20px;
    .product-list-title {
      padding: 20px 0;
      border-bottom: 1px solid #ebebeb;
    }
  }

  .product-list-box {
    padding: 8px 0 10px 0;
    .product-information {
      min-height: 80px;
      display: flex;
      justify-content: space-between;
      margin: 10px 0;
    }

    .product-information .product-list-left .image {
      width: 80px;
      height: 80px;
    }

    .product-information .product-list-right {
      flex: 1;
      padding-left: 12px;
    }
  }

  .product-list {
    padding: 10px 0;
  }

  .product-list-right-row {
    font-size: 12px;
    color: #919191;
  }

  .name-price .name {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }

  .more-product {
    text-align: center;
    padding: 10px 0 20px 0;
    color: #adadad;
    font-size: 14px;
    border-bottom: 1px solid #ebebeb;
  }

  /* 数量加减 */
  .product-list-number {
    padding: 16px 0 20px 90px;
    border-bottom: 1px solid #ebebeb;
    .input-box {
      width: 110px;
      display: flex;
      align-items: center;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      .btn-num {
        display: inline-block;
        width: 30px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        color: #f76f14;
        font-size: 20px;
        font-weight: bold;
      }
      .number-input {
        width: 50px;
        height: 28px;
        border: none;
        outline: none;
        border-left: 1px solid #e0e0e0;
        border-right: 1px solid #e0e0e0;
        padding: 0 10px;
        background-color: #f2f3f5;
        color: #919191;
      }
    }
  }

  .add-number {
    height: 30px;
    display: flex;
    align-items: center;
  }

  /* 价格输入框 */
  .price-input-box {
    height: 30px;
    display: flex;
    align-items: center;
    margin-top: 16px;
  }

  .price-input-box .price-input {
    width: 90px;
    height: 26px;
    border: none;
    outline: none;
    border: 1px solid #e0e0e0;
    background-color: #f2f3f5;
    border-radius: 4px;
    padding: 0 10px;
    color: #919191;
  }

  /* 数量、合计价格 */
  .product-number {
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 14px;
  }

  .product-number .total-title {
    margin-left: 20px;
  }

  .product-number .price {
    color: #f76f14;
    font-weight: bold;
  }

  /* 确认按钮 */
  .offer-bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 10px 0;
    position: fixed;
    left: 0;
    bottom: 0;
  }
  .price-box-input {
    width: 100px;
    height: 40px;
    border: none;
    outline: none;
    border: 1px solid #e0e0e0;
    padding: 0 10px;
    color: #919191;
    border-radius: 4px;
    background-color: #f2f3f5;
    margin: 2px 0 0 16px;
  }

  .offer-bottom .btn-affirm {
    /* width: 100%; */
    flex: 1;
    height: 46px;
    line-height: 46px;
    text-align: center;
    background: linear-gradient(
      260deg,
      rgba(247, 111, 20, 1),
      rgba(255, 144, 70, 1)
    );
    font-size: 18px;
    color: #ffffff;
    font-weight: bold;
    margin: 0 16px;
    border-radius: 4px;
  }
}
</style>